module.exports = __webpack_public_path__ + "img/general-placeholder.8c44c643.jpeg";